import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import URLstateContext from "../../../../provider/CommonContext";
import {
  GetMethodData,
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import { event } from "jquery";
import animation from "../../../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
function MeadiaVdieos() {
  const [FetchData, SetFetchData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [vdolist, setVdoList] = useState("");
  const [vdoid, setVdoId] = useState("0");
  const [SearchText, setSearchText] = useState("");
  const [pathname, setPathName] = useState("");
  const [loadingshow, setloadingshow] = useState(false);
  const [FetchDatavdo, setFetchDatavdo] = useState("");
  const [show, setShow] = useState(false);
  let DataFilter = [];
  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });
  useEffect(() => {
    setloadingshow(true);
    GetMethodData(BaseURL + "GetListVideos", {}).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setVdoList(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });

    GetPostMethodData(BaseURL + "GetLearnOurFunds", {
      IVOuput: "",
      IIPlaylistID: vdoid,
      IVsearch: SearchText,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        SetFetchData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL, vdoid, SearchText]);

  const handleChange = (event) => {
    setloadingshow(true);
    setVdoId(event);
    GetPostMethodData(BaseURL + "GetLearnOurFunds", {
      IVOuput: "",
      IIPlaylistID: event,
      IVsearch: SearchText,
    }).then(
      (data) => {
        setloadingshow(false);
        if (data.data != null && data.data.length > 0) {
          SetFetchData(DecryptAESdata(data.data));
          setloadingshow(false);
        }
      },
      [BaseURL, SearchText]
    );
  };
  const handleInputChange = (event) => {
    let Blogdata = event.target.value;
    // setSearchText(Blogdata);
    if (Blogdata.length >= 3) {
      setSearchText(Blogdata);
    } else {
      setSearchText("");
      // SetFetchData([]);
      // setShowPop(false);
    }
  };

  const clickyoutube = (event) => {
    setShow(true);
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    }, []);
  };

  const handleClosePopup = () => {
    setShow(false);
  };
  return (
    <>
      <section className="blog-sc global-blog-sc">
        <Container>
          <Row>
            <Container>
              <Col sm={12}>
                <Row>
                  {/* <Col sm={4}> */}

                  <>
                    <div className="ourFund-sch-prod">
                      <div className="ourFund-button">
                        {vdolist === null ? (
                          <h5 className="errormsgComNew">
                            No Data Available !!!
                          </h5>
                        ) : (
                          ""
                        )}
                        {vdolist &&
                          vdolist.map(({ Name, PlaylistID }) =>
                            PlaylistID == vdoid ? (
                              <>
                                <button
                                  className="active"
                                  onClick={(event) => handleChange(PlaylistID)}
                                  value={PlaylistID}
                                >
                                  {Name}
                                </button>
                              </>
                            ) : (
                              <button
                                className=" cursorpointer"
                                onClick={(event) => handleChange(PlaylistID)}
                                value={PlaylistID}
                              >
                                {Name}
                              </button>
                            )
                          )}
                      </div>
                      <div className="form-group-container mb-0">
                        <div className="form-group search-input mb-0">
                          <input
                            type="text"
                            className="ourFund-product"
                            name="SearchBlogs"
                            onChange={handleInputChange}
                            id="SearchBlogs"
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </div>
                  </>
                  {/* {loadingshow ? (
                    <div className="textcentervertex HomeLoader">
                      <img src={animation} alt="Loading" />
                      <div className="model_popup">Please Wait...</div>
                    </div>
                  ) : (
                    <div>
                      {FetchData.length === 0 ? (
                        <h5 className="errormsgComNew">No Data Available</h5>
                      ) : ( */}
                  <>
                    <div className="fund-container">
                      {FetchData === null ? (
                        <h5 className="errormsgComNew">
                          No Data Available !!!
                        </h5>
                      ) : (
                        ""
                      )}
                      {FetchData &&
                        FetchData.map(
                          ({ heading, ThumbnailImage, caption, srno }) => (
                            <div className="fund-inner zoom">
                              <h3>{heading}</h3>
                              <span onClick={(event) => clickyoutube(srno)}>
                                <img
                                  src={ThumbnailImage}
                                  className="img-fluid"
                                  alt="thumbnail"
                                ></img>
                              </span>
                              <p>{caption}</p>
                            </div>
                          )
                        )}
                      {loadingshow ? (
                        <div className="textcentervertex">
                          <img src={animation} alt="Loading" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                  {/* )}
                    </div>
                  )} */}
                  {FetchDatavdo &&
                    FetchDatavdo.map(({ heading, embeddedlink }) => (
                      <Modal show={show} className="modal modal-teams">
                        <Modal.Body id="modal_info">
                          <div className="btnDiv">
                            <div className="" onClick={handleClosePopup}>
                              <AiFillCloseCircle className="btncl" />
                            </div>
                          </div>
                          <div className="youtubepopup">
                            <p>{heading}</p>
                            <div>
                              <iframe
                                className="iframe-vdo"
                                src={embeddedlink}
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                              ></iframe>
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>
                    ))}
                </Row>
              </Col>
            </Container>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MeadiaVdieos;
